export const THOUSAND_SEPARATOR = ' ';
export const TRACE_ID_NAME = 'x-housing-trace-id';
export const EMPTY_VALUE = '—';
export const LTV_THRESHOLD = 90;
export const INTEREST_RATE_CALCULATION_DATE = new Date(2026, 5, 1); // Jun 1, 2026
export const MONTHS_IN_YEAR = 12;
/**
 * Fixed arrangement fee (in SEK) charged when establishing the loan. It is
 * deducted from the amount the customer effectively receives and is used by the
 * effective interest rate and total borrowing cost calculations.
 */
export const ARRANGEMENT_FEE = 950;
